/* ++++++++++ --------------- COMPANY INFO : STYLES --------------- ++++++++++ */
import {pxToEm, themeV2 } from "@insticator/insticator-ui";

export default {
  companyInfo: {
    '& .sectionCard': {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      columnGap: pxToEm(50),
      rowGap: pxToEm(25)
    }
  },
  field: {
    display: 'flex',
    flexDirection: 'column',

    '& .titleMargin': {
      marginBottom: pxToEm(10)
    },

    '& .text': {
      width: pxToEm(250)
    },

    '& .dropdown': {
      width: pxToEm(250),
      zIndex: 5
    }
  },
  updateSuccess: {
    color: themeV2.color.success.main
  },
  updateFailed: {
    color: themeV2.color.error.main
  }
};